import React from "react";
import { useFormikContext } from "formik";
import PropTypes from "prop-types";
import cx from "classnames";
import { Button, ProcessingButton } from "@qgiv/core-donor";

const Submit = ({ nextButtonLabel = "Next", handleClassificationSubmit }) => {
    const { isSubmitting, values, errors } = useFormikContext();
    // Disable the next button if a user has not selected a classification or
    // if there is a classification error
    const hasSelectedClassification = values.Classification.length > 0;
    const hasClassificationError = !!errors.Classification;
    const disabled = !hasSelectedClassification || hasClassificationError;

    // -------------------------------------------------------------------------
    // TODO: We need to make the processing background a separate component
    // from the processing button.
    // -------------------------------------------------------------------------
    return (
        // eslint-disable-next-line tailwindcss/classnames-order
        <div className="grid -margin-top--30">
            {/* Empty div used to easily match the width of the submit btn on the registration & payment pages */}
            <div className="col col--0 col--xl-6 -padding-top--0 -padding-bottom--0" />
            <div className="col col--12 col--xl-6">
                {isSubmitting ? (
                    <ProcessingButton />
                ) : (
                    <Button
                        classes={cx(disabled && "-disabled")}
                        type="submit"
                        name="Save_And_Continue"
                        disabled={disabled}
                        onClick={(e) => {
                            handleClassificationSubmit(e);
                        }}
                    >
                        {nextButtonLabel}
                    </Button>
                )}
            </div>
        </div>
    );
};

Submit.propTypes = {
    nextButtonLabel: PropTypes.string,
    handleClassificationSubmit: PropTypes.func.isRequired,
};

export default Submit;
